import React from "react";

function WhatWL() {
  return (
    <div className="container p-5">
      <div
        className="pricing-style-one-item-cos bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
        }}
      >
        <div className="text-center">
          <h3>What is White Label Crypto Exchange ?</h3>
          <div className="bottom">
            <div className="pricing">
              <p>
                A white label crypto exchange is a ready-made, customizable
                software solution that allows businesses to launch their own
                cryptocurrency exchange platform quickly. Essentially, it’s a
                pre-built crypto exchange platform that can be branded and
                tailored to meet specific requirements without having to develop
                the technology from scratch.
              </p>
            </div>
            <a className="btn btn-style-one mt-30" href="#">
              Get Started
            </a>
          </div>
        </div>
        {/* <div className="right-info"></div> */}
      </div>
    </div>
  );
}

export default WhatWL;
